<template>
  <div
    class="relative  flex items-center space-x-2 py-5 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-400 hover:bg-gray-50 w-80"
    @click="emit('abSelect', contact.id)"
  >
    <div class="flex-none px-1">
      <storm-ui-avatar
        :avatar="contact.avatar_url || 'null'"
        :fullname="contact.r_full_name"
        :initials="contact.initials.substring(0, 2)"
      />
    </div>
    <div class="min-w-0 flex-1">
      <a
        href="#"
        class="focus:outline-none"
      >

        <span
          class="absolute inset-0"
          aria-hidden="true"
        />
        <div class="font-normal">
          <p class="text-sm font-medium text-gray-900">{{ contact.full_name }}</p>
          <p class="truncate text-sm text-gray-500">{{ contact.company }}</p>
          <p class="truncate text-xs text-gray-500">{{ contact.zip }} {{ contact.city }}</p>
          <p class="truncate text-xs text-gray-500">{{ contact.email }}</p>
        </div>

      </a>
    </div>
  </div>
</template>
<script setup>
import { useProp } from '@/composables/useProp.js'

const emit = defineEmits(['abSelect'])

defineProps({
  contact: useProp(Object)
})

</script>
